import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";

const DEFAULT_DEBOUNCE = 200;
const DEFAULT_LIMIT = 12;

export function useProductSearch({
    limit = DEFAULT_LIMIT,
    debounceMs = DEFAULT_DEBOUNCE,
    externalQuery,
} = {}) {
    const [internalQuery, setInternalQuery] = useState("");
    const query = externalQuery !== undefined ? externalQuery : internalQuery;
    const setQuery = setInternalQuery;
    const [results, setResults] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const reqId = useRef(0);

    useEffect(() => {
        const trimmed = query.trim();
        if (!trimmed) {
            setResults([]);
            setTotal(0);
            setLoading(false);
            return undefined;
        }

        setLoading(true);
        const t = setTimeout(() => {
            const id = ++reqId.current;
            api.get("/products", { params: { q: trimmed, limit, sort: "name" } })
                .then((r) => {
                    if (id !== reqId.current) return;
                    setResults(r.data.items || []);
                    setTotal(r.data.total || 0);
                })
                .catch(() => {
                    if (id !== reqId.current) return;
                    setResults([]);
                    setTotal(0);
                })
                .finally(() => {
                    if (id === reqId.current) setLoading(false);
                });
        }, debounceMs);

        return () => clearTimeout(t);
    }, [query, limit, debounceMs]);

    return { query, setQuery, results, total, loading };
}
